import React, { useState } from 'react';
import FeatherIcon from 'feather-icons-react';
import { useBrandVoice } from '../contexts/BrandVoiceContext';

export default function BrandVoiceFields() {
  const {
    brandVoice,
    updateBrandVoice,
    clearBrandVoice,
    isBrandVoiceActive
  } = useBrandVoice();

  const [urlError, setUrlError] = useState(false);

  const validateUrl = (url) => {
    if (!url.trim()) return true;
    const urlPattern = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;
    return urlPattern.test(url);
  };

  const handleFieldChange = (field, value) => {
    updateBrandVoice(field, value);
    if (field === 'company_website' && urlError && validateUrl(value)) {
      setUrlError(false);
    }
  };

  const handleWebsiteBlur = () => {
    if (brandVoice.company_website && !validateUrl(brandVoice.company_website)) {
      setUrlError(true);
    } else {
      setUrlError(false);
    }
  };

  const handleClear = () => {
    clearBrandVoice();
    setUrlError(false);
  };

  return (
    <div className="brand-voice-form">
      <div className="form-field">
        <label htmlFor="company_name">Company Name</label>
        <input
          type="text"
          id="company_name"
          value={brandVoice.company_name}
          onChange={(e) => handleFieldChange('company_name', e.target.value)}
          placeholder="Your company name"
        />
      </div>

      <div className="form-field">
        <label htmlFor="company_sector">Company Sector</label>
        <input
          type="text"
          id="company_sector"
          value={brandVoice.company_sector}
          onChange={(e) => handleFieldChange('company_sector', e.target.value)}
          placeholder="e.g., Technology, Healthcare, Finance"
        />
      </div>

      <div className="form-field">
        <label htmlFor="company_website">Company Website</label>
        <input
          type="text"
          id="company_website"
          value={brandVoice.company_website}
          onChange={(e) => handleFieldChange('company_website', e.target.value)}
          onBlur={handleWebsiteBlur}
          placeholder="www.yourcompany.com"
          className={urlError ? 'input-error' : ''}
        />
        {urlError && (
          <span className="error-text">Please enter a valid URL</span>
        )}
      </div>

      <div className="form-field">
        <label htmlFor="company_description">Company Description</label>
        <textarea
          id="company_description"
          value={brandVoice.company_description}
          onChange={(e) => handleFieldChange('company_description', e.target.value)}
          placeholder="Brief description of what your company does"
          rows="2"
        />
      </div>

      <div className="form-field">
        <label htmlFor="company_tov">Tone of Voice</label>
        <input
          type="text"
          id="company_tov"
          value={brandVoice.company_tov}
          onChange={(e) => handleFieldChange('company_tov', e.target.value)}
          placeholder="e.g., Professional, Friendly, Technical"
        />
      </div>

      {isBrandVoiceActive() && (
        <button
          type="button"
          className="clear-button"
          onClick={handleClear}
        >
          <FeatherIcon icon="x" size={16} />
          Clear All
        </button>
      )}
    </div>
  );
}
